var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "mails" } },
    [
      _c("a-spin", { attrs: { spinning: _vm.loading } }, [
        _vm.allMediaCount > 0
          ? _c(
              "div",
              { staticClass: "row container" },
              _vm._l(_vm.allMedias, function (item) {
                return _c("div", { staticClass: "attachments" }, [
                  _c(
                    "div",
                    { staticClass: "info" },
                    [
                      _c("div", { staticClass: "info-item time" }, [
                        _vm._v(_vm._s(_vm.getTime(item.created_at))),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v(" " + _vm._s(_vm.$t("message.sender")) + ": "),
                        ]),
                        _c("span", [_vm._v(" " + _vm._s(item.sender) + " ")]),
                      ]),
                      _vm._v(" "),
                      _vm._l(item.to_list, function (to) {
                        return _c("div", { staticClass: "info-item" }, [
                          _c("span", { staticClass: "label" }, [
                            _vm._v(" To: "),
                          ]),
                          _c("span", [_vm._v(" " + _vm._s(to) + " ")]),
                        ])
                      }),
                      _vm._v(" "),
                      _vm._l(item.cc_list, function (cc) {
                        return item.cc_list.length > 0
                          ? _c("div", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v(" CC: "),
                              ]),
                              _c("span", [_vm._v(" " + _vm._s(cc) + " ")]),
                            ])
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm._l(item.bcc_list, function (bcc) {
                        return item.bcc_list.length > 0
                          ? _c("div", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v(" BCC: "),
                              ]),
                              _c("span", [_vm._v(" " + _vm._s(bcc) + " ")]),
                            ])
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    _vm._l(item.attachments, function (attachment) {
                      return _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "column",
                          },
                        },
                        [
                          attachment.assetType === "image"
                            ? _c("ImageMessage", {
                                attrs: { message: attachment },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          attachment.assetType === "asset"
                            ? _c("AssetMessage", {
                                attrs: {
                                  message: attachment,
                                  "extended-style": _vm.extendedStyle(),
                                  "message-colors": _vm.receivedColorsStyle(),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ])
              }),
              0
            )
          : _c("div", { staticClass: "data-box" }, [
              _c("div", { staticClass: "last-session-info" }, [
                _c(
                  "div",
                  {
                    staticClass: "material-icons",
                    staticStyle: { "font-size": "20px" },
                  },
                  [_vm._v("block")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "last-session-data",
                    staticStyle: { "margin-top": "5px" },
                  },
                  [_vm._v(_vm._s(_vm.$t("visitor.notUserData")))]
                ),
              ]),
            ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }